export default __webpack_public_path__ + "native-ios@2x.png";